export default {
  // Título de la sección y acciones generales
  index: 'Permisos',
  ablePublish: 'Permitir publicación',
  geolocation: 'Activar/desactivar geolocalización',

  // Permisos con subpermisos (acceso a módulo + alcance)
  franchises: 'Acceso a Unidades de negocio',
  locations: 'Acceso a Ubicaciones',
  roles: 'Acceso a Roles',
  users: 'Acceso a Usuarios',
  forms: 'Acceso a Formularios',
  catalogs: 'Acceso a Catálogos',
  routines: 'Acceso a Rutinas',
  galleries: 'Acceso a Galería de Imagenes',

  // Permisos simples (acceso a módulo)
  sprints: 'Acceso a Sprints',
  campaigns: 'Acceso a Campañas',
  mailing: 'Acceso a Mailing',
  notifications: 'Acceso a Centro de Notificaciones',
  notices: 'Crear Noticias',
  'general-settings': 'Acceso a Configuración',

  // Permisos de formularios (roles especiales)
  'form-creator': 'Creador de Formularios',
  'form-tester': 'Tester de Formularios',
  'form-approver': 'Aprobador de Formularios',

  // Otros permisos especiales
  'assign-exhibitions': 'Asignar Exhibiciones'
}
